import { createContext } from "react";
import type { DrawingActions } from "../DrawingProvider.types";

const DrawingActionsContext = createContext<DrawingActions | undefined>(undefined);
DrawingActionsContext.displayName = "DrawingActionsContext";

export default DrawingActionsContext;
